/**
 * Generic Connections Tab Wrapper
 * 
 * This is a wrapper around DocConnectionsTab that handles:
 * - Empty state for new documents
 * - Integration with tab system
 * - Generic doctype support
 * 
 * Architecture: Page-level tab, not part of TabRenderer
 */

import { DocConnectionsTab } from './DocConnectionsTab';

interface ConnectionsTabProps {
  doctype: string;
  name?: string;
  /**
   * Optional list of connection group IDs to show.
   * Passed through to DocConnectionsTab for filtering.
   */
  connectionGroups?: string[];
}

/**
 * Generic Connections Tab wrapper.
 * 
 * Automatically handles:
 * - Empty state when document is new
 * - Loading states (handled by DocConnectionsTab)
 * - Error states (handled by DocConnectionsTab)
 * 
 * Works for any doctype - fully meta-driven.
 */
export function ConnectionsTab({ doctype, name, connectionGroups }: ConnectionsTabProps) {
  // Don't render for new documents
  if (!name || name === 'new') {
    return (
      <div className="flex items-center justify-center py-12">
        <p className="text-sm text-muted-foreground">
          Connections will be available after this document is saved.
        </p>
      </div>
    );
  }
  
  return <DocConnectionsTab doctype={doctype} name={name} connectionGroups={connectionGroups} />;
}
